const html = {
  methods: {
    decodeHtml(html) {
      if (!html || typeof html !== 'string') {
        return html
      }
      // Use a temporary DOM element to properly decode HTML entities
      // This handles both named entities (&nbsp;, &amp;) and numeric entities (&#160;, &#38;)
      // Using textarea preserves HTML structure while decoding entities
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      let decoded = txt.value

      // Handle numeric character references that textarea might not decode properly
      // Replace numeric character references manually if they still exist
      if (decoded.includes('&#')) {
        decoded = decoded.replace(/&#(\d+);/g, (match, dec) => {
          return String.fromCharCode(parseInt(dec, 10))
        })
        // Handle hexadecimal numeric references
        decoded = decoded.replace(/&#x([0-9a-fA-F]+);/g, (match, hex) => {
          return String.fromCharCode(parseInt(hex, 16))
        })
      }

      return decoded
    },
    /**
     * Decodes common HTML entities via string replace only (no DOM).
     * Safe for mixed strings that also contain raw `<>` / `<word>` — unlike textarea.innerHTML.
     * Decodes &amp; first so sequences like &amp;lt; resolve in a second named pass if needed.
     */
    decodeHtmlEntitiesSafe(value: string): string {
      if (value == null || typeof value !== 'string') {
        return value || ''
      }
      if (!/&(?:[a-z]+|#\d+|#x[0-9a-fA-F]+);/i.test(value)) {
        return value
      }
      return value
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#0*39;/g, "'")
        .replace(/&#x0*27;/gi, "'")
        .replace(/&#(\d+);/g, (_match, dec) => String.fromCharCode(parseInt(dec, 10)))
        .replace(/&#x([0-9a-fA-F]+);/gi, (_match, hex) => String.fromCharCode(parseInt(hex, 16)))
    },
    /**
     * Ensures all <p> tags in the given HTML string have a style attribute with margin:0.
     * - Adds style="margin:0" to <p> tags without a style attribute.
     * - Appends margin:0 to existing style attributes if margin is not already set.
     */
    removeParagraphMargins(html: string): string {
      if (!html || typeof html !== 'string') {
        return html
      }
      let updated = html.replace(/<p(?![^>]*style=)([^>]*)>/gi, '<p$1 style="margin:0">')
      updated = updated.replace(/<p([^>]*)style="([^"]*)"([^>]*)>/gi, (match, before, style, after) => {
        if (/margin\s*:/i.test(style)) {
          return match
        }
        const newStyle = (style.trim().length ? style.trim() + '; ' : '') + 'margin:0'
        return `<p${before}style="${newStyle}"${after}>`
      })
      return updated
    }
  }
}

export { html }
